var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEvent = function SvgEvent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6152_13873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 3.22807C4.376 3.22807 5.096 3.63158 5.688 4.34175C6.128 3.86561 6.648 3.5186 7.2 3.34912V1.61404C7.2 1.18597 7.36857 0.77543 7.66863 0.47274C7.96869 0.17005 8.37565 0 8.8 0H10.4V1.61404H8.8V3.34912C9.352 3.5186 9.872 3.86561 10.312 4.34175C10.904 3.63158 11.624 3.22807 12.4 3.22807C14.4 3.22807 16 5.93965 16 9.2807C16 12.6218 14.4 15.3333 12.4 15.3333C11.624 15.3333 10.904 14.9298 10.312 14.2196C9.664 14.9298 8.864 15.3333 8 15.3333C7.136 15.3333 6.336 14.9298 5.688 14.2196C5.096 14.9298 4.376 15.3333 3.6 15.3333C1.6 15.3333 0 12.6218 0 9.2807C0 5.93965 1.6 3.22807 3.6 3.22807ZM5.6 6.45614L4.6 8.27193H6.6L5.6 6.45614ZM10.4 6.45614L9.4 8.27193H11.4L10.4 6.45614ZM4.8 12.1053H6.4L7.2 11.2982L8 12.1053H9.6L10.4 11.2982L11.2 12.1053L12.4 9.68421L9.536 10.1846L8.8 11.2982L8 10.4912H6.4L5.6 11.2982L4.8 10.4912L3.2 9.68421L4.8 12.1053Z",
    fill: "#9EA7B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6152_13873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/event.743bf034.svg";
export { ForwardRef as ReactComponent };